module.exports = __webpack_public_path__ + "img/coupon_300.5a6150c8.png";